import * as React from 'react'
import styled from 'styled-components'

import { COLORS } from '@ulule/owl-kit-components/next'

type BrowserScreenshotProps = {
  className?: string
  ratio?: number
  children: React.ReactNode
  href?: string
}

function BrowserScreenshotComponent({
  className,
  ratio = 16 / 9,
  children,
  href,
}: BrowserScreenshotProps): React.ReactElement<BrowserScreenshotProps> {
  return (
    <Wrapper className={className}>
      <RatioPreserver $ratio={ratio}>
        <BrowserWrapper>
          <BrowserBar>
            <Button $type="close" />
            <Button $type="minimise" />
            <Button $type="maximise" />
            <NavigationBar>{href}</NavigationBar>
          </BrowserBar>
          {children}
        </BrowserWrapper>
      </RatioPreserver>
    </Wrapper>
  )
}

const buttonColors = { close: '#FF605C', minimise: '#FFBD44', maximise: '#00CA4E' } as const
const Button = styled.div<{ $type: 'close' | 'minimise' | 'maximise' }>`
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background-color: ${({ $type }) => COLORS.hexToRgb(buttonColors[$type], 0.8)};
  border: 1px solid ${({ $type }) => buttonColors[$type]};
`

const NavigationBar = styled.div`
  background-color: white;
  border: 1px solid #d0d1d1;
  flex: 1;
  border-radius: 2px;
  margin: 0 10px 0 20px;
  height: 10px;
  font-size: 7px;
  line-height: 10px;
  padding: 0 10px;
  color: #444;
`

const BrowserBar = styled.div`
  position: relative;
  background-color: #e0dddd;
  display: flex;
  padding: 4px;
  z-index: 1;

  ${Button} {
    margin: 2px;
  }
`

const BrowserWrapper = styled.div`
  pointer-events: none;
  user-select: none;
  border: 1px solid #e0dddd;
`

const RatioPreserver = styled.div<{ $ratio: number }>`
  position: relative;
  padding-bottom: ${({ $ratio }) => (1 / $ratio) * 100}%;

  ${BrowserWrapper} {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
  }
`

const Wrapper = styled.div``

export const BrowserScreenshot = styled(BrowserScreenshotComponent)``
